<div (click)="openBatchSelector()" class="batch-values-selector">
  <mat-spinner *ngIf="loading" class="batch-values-selector-loading-icon" diameter="18"></mat-spinner>
  <input class="batch-input" disabled="true" [value]="numberAppliedLabel" />
  <button class="batch-button">
    <mat-icon>list_alt</mat-icon>
  </button>
</div>
